import React, { useState, useEffect } from "react";
import Modal from "../../../components/ui/Modal";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import UserService from "../../../service/UserService";
import { API_URL } from "helper/Constants";

const ManageUserBalanceModal = ({
  isOpen,
  onClose,
  userId,
  setUserId
}) => {
  const userService = new UserService(API_URL);
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [balanceLimit, setBalanceLimit] = useState("");
  const [initialBalance, setInitialBalance] = useState("");
  const [isGlobalLimit, setIsGlobalLimit] = useState(true);

  // Fetch user balance when modal opens
  useEffect(() => {
    const fetchBalance = async () => {
      if (!userId) return;
      try {
        const response = await userService.getUserBalanceLimit(userId);
        if (response?.limit) {
          setBalanceLimit(response.limit);
          setInitialBalance(response.limit); // store original balance
        } else {
          setBalanceLimit("");
          setInitialBalance("");
        }
        if(response.type != 'global'){
          setIsGlobalLimit(false)
        }
      } catch (err) {
        console.error("Failed to fetch balance limit", err);
        setBalanceLimit("");
        setInitialBalance("");
      }
    };
    fetchBalance();
  }, [userId]);

  // Update Balance Limit (Admin)
  const updateBalanceHandler = async () => {
    if (!userId) {
      toast.error("Please select a user first");
      return;
    }

    try {
      setLoading(true);

      const response = await userService.updateUserBalanceLimit(userId, {
        limit: balanceLimit,
      });

      if (response.success) {
        toast.success("Balance limit updated successfully!");
        setUserId("");
        onClose(); // close modal on success
      } else {
        toast.error(response.message || "Failed to update balance limit");
      }
    } catch (error) {
      console.error("Error updating balance limit:", error);
      toast.error(
        error.response?.data.message ||
          "An error occurred while updating balance limit"
      );
    } finally {
      setLoading(false);
    }
  };

  // Button should be disabled if no change
  const isDisabled =
    loading || balanceLimit === "" || String(balanceLimit) === String(initialBalance);

  const useGlobalLimit = async () => {
    if (!userId) {
      toast.error("Please select a user first");
      return;
    }

    try {
      setLoading(true);

      const response = await userService.updateUserBalanceLimit(userId, {
        limit: null,
      });

      if (response.success) {
        toast.success("Balance limit updated successfully!");
        setUserId("");
        onClose(); // close modal on success
      } else {
        toast.error(response.message || "Failed to update balance limit");
      }
    } catch (error) {
      console.error("Error updating balance limit:", error);
      toast.error(
        error.response?.data.message ||
          "An error occurred while updating balance limit"
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        setUserId("");
        onClose();
      }}
      className="w-full max-w-[28rem] overflow-hidden !h-[240px]"
      title={<h2 className="font-bold text-xl py-4">{t("Manage User Balance")}</h2>}
    >
      <div className="flex flex-col px-5 gap-5">
        {/* Balance Limit Section */}
        <div>
          <label className="block font-bold">{t("Balance Limit")}</label>
          <input
            value={balanceLimit}
            onChange={(e) => setBalanceLimit(e.target.value)}
            className="text-left w-full p-2 border border-slate-800 rounded text-black"
          />
        </div>

        <button
          disabled={isDisabled}
          onClick={updateBalanceHandler}
          className={`mt-3 w-full font-bold py-2 rounded ${isDisabled ? "bg-primary/65" : "bg-primary hover:bg-primary/80"}  text-black`}
        >
          {loading ? "Loading..." : "Update Balance"}
        </button>
        {!loading && !isGlobalLimit &&
         <button
         onClick={useGlobalLimit}
         className={`mt-3 w-full font-bold py-2 rounded bg-primary hover:bg-primary/80 text-black`}
         >Use Global Limit</button>
        }
      </div>
    </Modal>
  );
};

export default ManageUserBalanceModal;